import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import $ from 'jquery';  
import { Redirect, Link, withRouter } from 'react-router-dom';
import Pagination from "react-js-pagination";


const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');

class Programmes extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          	loaded: true,
            Volunteer:[],
			languagedata:[],
			defaultlang:6,
			Programmes:[],
			AllProgrammesCount:0,
			AllCityCount:0,
			AllStateCount:0,
			activePage: 1,
            TotalActiveProgrammes:'',
            pageNumber:1,
            perpage:8,


			
			
        };
		this.handlePageChange = this.handlePageChange.bind(this);
    }
componentDidMount() {

	$('html, body').animate({
		scrollTop:0
		}, 1000);
	
   
}

componentWillMount() {
  
    
    const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }

    const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});


	
	this.getprogrammedata(DefaultLang);

      this.getlanguage(DefaultLang);
    
  }


getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}	

	
getprogrammedata(DefaultLang)
{
	this.setState({ loaded: true });
	axios.post(`${API_URL}/getprogrammes`, { 
		LanguageId:DefaultLang,
		pageNumber:this.state.pageNumber,
        perpage:this.state.perpage
	})
			  
			  .then(res => {
				
				if(res.data.Status == 1)
				{
					const Programmes = res.data.ResponseData.Programmes;
					const AllProgrammesCount = res.data.ResponseData.TotalProgrammes;
					const AllCityCount = res.data.ResponseData.TotalCity;
					const AllStateCount = res.data.ResponseData.TotalState;
					const TotalActiveProgrammes = res.data.ResponseData.TotalActiveProgrammes;
					this.setState({ Programmes });
					this.setState({ AllProgrammesCount });
					this.setState({ TotalActiveProgrammes });
					this.setState({ AllCityCount });
					this.setState({ AllStateCount });
					this.setState({ loaded: false });
				
				}else{
					
					this.setState({ Programmes:[] });
					this.setState({ AllProgrammesCount : 0 });
					this.setState({ AllCityCount : 0 });
					this.setState({ AllStateCount : 0 });
					this.setState({ TotalActiveProgrammes: 0 });
				}
				
			  })
	
}	

handlePageChange(pageNumbers) {
    console.log(`active page is ${pageNumbers}`);
    this.setState({activePage: pageNumbers});
    const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({ loaded: true });
	axios.post(`${API_URL}/getprogrammes`, { 
		LanguageId:DefaultLang,
		pageNumber:pageNumbers,
        perpage:this.state.perpage
	})
			  
			  .then(res => {
				
				if(res.data.Status == 1)
				{
					const Programmes = res.data.ResponseData.Programmes;
					const AllProgrammesCount = res.data.ResponseData.TotalProgrammes;
					const AllCityCount = res.data.ResponseData.TotalCity;
					const AllStateCount = res.data.ResponseData.TotalState;
					const TotalActiveProgrammes = res.data.ResponseData.TotalActiveProgrammes;
					this.setState({ Programmes });
					this.setState({ AllProgrammesCount });
					this.setState({ AllCityCount });
					this.setState({ AllStateCount });
					this.setState({ TotalActiveProgrammes });
					this.setState({ loaded: false });
				
				}else{
					
					this.setState({ Programmes:[] });
					this.setState({ AllProgrammesCount : 0 });
					this.setState({ AllCityCount : 0 });
					this.setState({ AllStateCount : 0 });
					this.setState({ TotalActiveProgrammes: 0 });
				}
				
			  })
   
  }	

  render() {

	  
	  
	  
    return (
      <div className="App">
	  
          <Layout languagedata={this.state.languagedata}>
	  {this.state.loaded == true ? (	  
		 
	<div className="divloader"> 
		 <Loader 
			 type="ThreeDots"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }
	<section className="banner inner_banner">
	  <div className="bd-example">
	    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
	      <div className="carousel-inner">
	        <div className="carousel-item active">
	          <img src={ IMAGE_URL+'/images/PROGRAMMES-banner.jpg' } className="d-block w-100" alt={"Swacch Bharat - "+this.state.languagedata.programmes} />
	          <div className="carousel-caption d-none d-md-block">
	            <h1>{this.state.languagedata.programmes}</h1>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</section>
	<section className="programe">
<div className="container">
<div className="row">
<div className="col-12">
<ul className="list-unstyled">
{this.state.Programmes.map((item) =>
		    <li>
  				<div className="pro_img">
		        <img src={item.ProgrammeImage} alt={"programmes - "+item.ProgrammeTitle}/>
		        	<Link to={ "/Programmes/"+item.ProgrammeID } >
		        	<div className="overlay">
		        	 	<span>Volunteers - {item.ProgrammeVolunteers}</span>
				    	<span>Date : {item.ProgrammeDate}</span>
				    </div>
				    </Link>	
				</div>
		      	<p>{item.ProgrammeTitle}</p>
			</li>
		      )}

</ul>
<div className="clearfix"></div>
</div>
</div>
<div className="row">
<div className="col-12">
<div className="Our_Volunteers">
<Pagination
			    prevPageText='prev'
			    nextPageText='next'
			    firstPageText='first'
			    lastPageText='last'
			    itemClassFirst='volunteer-pagination-list'
			    itemClassPrev='volunteer-pagination-list'
			    itemClassNext='volunteer-pagination-list'
			    itemClassLast='volunteer-pagination-list'
	      		itemClass='page-item'
	          	activePage={this.state.activePage}
	          	itemsCountPerPage={8}
	          	totalItemsCount={this.state.TotalActiveProgrammes}
	          	pageRangeDisplayed={5}
	          	onChange={this.handlePageChange}
        	/>
</div>
</div>
</div>
</div>
</section>

<section className="programe_two">
<div className="container">
<div className="row">
<div className="col-12">
<h2>{this.state.languagedata.our_impact}</h2>
</div>
</div>
<div className="row">
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.Projects}</aside>
<span>{this.state.AllProgrammesCount}</span>
	
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.Cities}</aside>
<span>{this.state.AllCityCount}</span>
	
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.State}</aside>
<span>{this.state.AllStateCount}</span>
	
</div>
</div>
</div>
</div>
</section>
		

		<Callusnow languagedata={this.state.languagedata} />
		
      </Layout>
      </div>
    );
  }
}

export default Programmes;



// WEBPACK FOOTER //
// ./src/component/Programmes.js